class Product {
  constructor() {
      this.bindInit();
  }
  bindInit() {
    this.backOrderDate();
    this.orderDatePopup();
    this.productTabs();
    this.buttonBIS();
  }


  backOrderDate() {
    const currentVariant = document.querySelector('.product-variant-id');
    const expectedDeliveryDate = document.querySelector('.js-expectedDeliveryDate');
    const expectedDeliveryDateContainer = document.querySelector('.backOrderHelpMessage');
    const orderDate = document.querySelectorAll(".js-back-order-date");
    const orderDateSingle = document.querySelector(".js-select-dropdown");

    if(orderDate.length) {
      orderDate.forEach(getorderDate => {
        if (currentVariant.value === getorderDate.getAttribute('data-id')) {
          expectedDeliveryDate.innerHTML = getorderDate.getAttribute('back-order-date');
          expectedDeliveryDateContainer.classList.add('is-active');
        }
      });

      orderDateSingle.addEventListener("change", () => {
        setTimeout(function () {

          for (var i = 0; i < orderDate.length; i++) {
            if (currentVariant.value === orderDate[i].getAttribute('data-id')) {
              expectedDeliveryDate.innerHTML = orderDate[i].getAttribute('back-order-date');
              expectedDeliveryDateContainer.classList.add('is-active');

              break;
            } else {
              expectedDeliveryDateContainer.classList.remove('is-active');
            }
          }
        }, 500);
      });
    }
  }

  orderDatePopup() {
    const orderDateContainer = document.querySelector('.js-popup-container');
    const OrderDateLink = document.querySelector('.js-popup');
    const closePopup = document.querySelector('.js-close')

    OrderDateLink.addEventListener("click", () => {
      orderDateContainer.classList.add('is-active');
    });

    closePopup.addEventListener("click", () => {
      orderDateContainer.classList.remove('is-active');
    })
  }

  productTabs() {
    const tabContent = document.querySelectorAll(".js-tab-description");
    const tabTitle = document.querySelectorAll(".js-tab-link");

    tabTitle.forEach(getTabTitle => {
        getTabTitle.addEventListener("click", () => {
          tabContent.forEach(gettabContent => {
              if (gettabContent.getAttribute('data-value') === getTabTitle.getAttribute('data-value')) {
                  gettabContent.classList.toggle('is-active');
              } else {
                gettabContent.classList.remove('is-active');
              }
          });

          tabTitle.forEach(listTabTitle => {
            if (listTabTitle.getAttribute('data-value') === getTabTitle.getAttribute('data-value')) {
              listTabTitle.classList.toggle('is-active');
            } else {
              listTabTitle.classList.remove('is-active');
            }
          });
        });
    });
  }

  buttonBIS() {
    const BISButton = document.querySelector(".js-bis-button");
    const addToCart = document.querySelector(".js-add-to-cart");
    const checkAvailability = document.querySelector("select.js-select-dropdown");
    const checkAvailabilityRadio = document.querySelector("fieldset.js-select-dropdown");

    if (BISButton) {

      function toggleButtons(stockAvailability) {
        if (parseInt(stockAvailability) === 1) {
          BISButton.style.display = "none";
          addToCart.style.display = "block";
        } else {
          BISButton.style.display = "block";
          addToCart.style.display = "none";
        }
      }

      if (checkAvailability) {
        function updateDropdown() {
          const selected = checkAvailability.options[checkAvailability.selectedIndex];
          const stock = selected.getAttribute('stock-availability');
          toggleButtons(stock)
        }
        checkAvailability.addEventListener("change", updateDropdown)
        updateDropdown();
      }

      if (checkAvailabilityRadio) {
        const pills = checkAvailabilityRadio.querySelectorAll('input[type="radio"]');

        function updateRadio() {
          const selected = checkAvailabilityRadio.querySelector('input[type="radio"]:checked');
          const stock = selected.getAttribute('stock-availability')
           toggleButtons(stock)
          }

        pills.forEach(pill => pill.addEventListener("change", updateRadio))
        updateRadio();
      }

    }
  }
}

new Product();
